module.exports = __webpack_public_path__ + "static/media/ph.009c7337.svg";